import { cn } from "@/lib/utils"

// Shared disclosure marker: a ▸ glyph that rotates 90° (→ ▾) when open. Replaces
// the hand-rolled ▾/▸ glyph swaps. A tiny presentational span with no shadcn
// equivalent (the small-helper carve-out of the prefer-shadcn rule).
export const DisclosureChevron = ({
  isOpen,
  className,
}: {
  isOpen: boolean
  className?: string
}) => (
  <span
    aria-hidden="true"
    className={cn(
      "inline-flex translate-y-[-0.075em] leading-none transition-transform duration-(--duration-base) ease-out",
      isOpen && "rotate-90",
      className
    )}
  >
    ▸
  </span>
)
